export const FASTTRACK_INITIALIZED_CONSOLE_MESSAGE = 'private-prisma-396-2934';